import { create } from 'zustand';

import { createSelectAllSlice, type SelectAllSlice } from './slices/createSelectAllSlice';

export type ViewsSelectAllState = SelectAllSlice;

export const useViewsSelectAllStore = create<ViewsSelectAllState>()(
  createSelectAllSlice({ selectAll: false, includeNestedItems: false }),
);
